import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';

//Componentes
import TextField from '../../../components/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';

//API
import tipoDeFiscalizacao_api from '../../../api/tipoDeFIscalizacao_api';
import usuario_api from '../../../api/usuario_api';
import fiscalizacao_api from '../../../api/fiscalizacao_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { objCampo, validarCampos, isDateOverflow } from '../../../helpers/ValidadorDeCampos';
import { criarOnChangeMultiSelect } from '../../../helpers/onChangeMultiSelect';
import { getSessionCookie } from '../../../helpers/cookies';

//Context
import { useAuth } from '../../../context/auth';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

function initialStateConsultaFiscalizacao() {
    const dataInicial = new Date();
    dataInicial.setMonth(dataInicial.getMonth() - 1);

    return {
        tipoFiscalizacao_Ids: [],
        logradouro: null,
        bairro: null,
        numero: null,
        codigoItem: null,
        codigoCadastro: null,
        dataFiscalizacaoInicial: moment(dataInicial).format('YYYY-MM-DD'),
        dataFiscalizacaoFinal: moment(new Date()).format("YYYY-MM-DD"),
        usuario_Id: null,
        nomeInfrator: null,
        periodoDatas: "Data Lavratura",
        situacao: "Infrações Apontadas"
    }
}

function ConsultaFiscalizacao() {
    //Objeto token
    const session = getSessionCookie();

    //State para consultar fiscalizacoes
    const [consultaFiscalizacao, setConsultaFiscalizacao] = useState(initialStateConsultaFiscalizacao());

    //State para pegar lista dos tipos de fiscalizacao
    const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

    //State para lista de fiscalizacao
    const [listFiscalizacoes, setListFiscalizacoes] = useState([]);

    //State para pegar os perfil dos usuarios
    const [listUsuarios, setListUsuarios] = useState([]);

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //Estado que pega os dados passados via navegação
    const location = useLocation();

    //Estado de navegação
    const navigate = useNavigate();

    //pegando a etapa selecionada no 
    const { filtro } = location.state ? location.state : {};

    const { setLoading } = useAuth();

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "tipoFiscalizacao_Ids", required: true })
    ]);

    //Cabeçalhos da lista de consulta fiscalização
    const headers = [
        { value: "Tipo de Fiscalização", objectValue: "tipoFiscalizacao_Identificacao", align: "left" },
        { value: "Tipo de Serviço", objectValue: "tipoFiscalizacaoServico_Identificacao", align: "left" },
        { value: "Endereço da Fiscalização", objectValue: "enderecoCompleto", align: "left" },
        { value: "Data da Fiscalização", objectValue: "dataFiscalizacao", align: "left" },
        { value: "Data Lavratura", objectValue: "dataHoraPreenchimento", align: "left" },
        { value: "Usuário", objectValue: "usuario_Nome", align: "left" },
        { value: "Nome do Infrator", objectValue: "nomeInfrator", align: "left" },
        { value: "Situação", objectValue: "situacao", align: "left" }
    ];

    // [Situacao]='Pendente' OR [Situacao]='Infrações Apontadas' OR [Situacao]='Sem Infrações'
    const [situacao, setSituacao] = useState([
        { value: "Infrações Apontadas", label: "Infrações Apontadas" },
        { value: "Sem Infrações", label: "Sem Infrações" }
    ])

    const visualizarFiscalizacao = (fiscalizacao) => {
        navigate("/admin/ficha-fiscalizacao", { state: { fiscalizacao_id: fiscalizacao.id, filtro: consultaFiscalizacao, btnVoltar: "/admin/consultaFiscalizacao", originPath: "/admin/ficha-fiscalizacao" } })
    }

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.visualizar(visualizarFiscalizacao)];

    //Carregar tipos da fiscalização
    const loadTipoDeFiscalizacao = () => {
        setLoading(true);
        tipoDeFiscalizacao_api.getListAtivos()
            .then(response => {
                response.data.map(value => {
                    value.value = value.id;
                    value.label = value.identificacao;
                    return value;
                })
                setListTipoDeFiscalizacao(response.data)
            })
            .catch(err => showMessage("Error", err.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    };

    //Função que carrega a lista de formularios
    const loadUsuarios = () => {
        setLoading(true);
        usuario_api.GetListAtivos().then(response => {
            response.data.map(value => {
                value.value = value.id;
                value.label = value.nome;
                return value;
            })
            setListUsuarios(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    };

    useEffect(() => {
        loadTipoDeFiscalizacao();
        loadUsuarios();

        if (filtro) {
            setConsultaFiscalizacao({ ...filtro })
            handleConsultaFiscalicacao(filtro)
        }

    }, []);

    //Função para campos select
    const onChangeSelect = (value, e) => {
        const _consultaFiscalizacao = {
            ...consultaFiscalizacao,
            [e.name]: value ? value.value.toString() : null,
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === e.name);
        const fieldError = validarCampos(_consultaFiscalizacao, _campos);

        const _errors = { ...errors };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setConsultaFiscalizacao(_consultaFiscalizacao);
    }

    //Função para campos select de múltipla escolha
    const onChangeMultiSelect = criarOnChangeMultiSelect({
        state: consultaFiscalizacao,
        setState: setConsultaFiscalizacao,
        campos,
        errors,
        setErrors
    });

    //Função para campos sem ser select
    const onChange = (e) => {
        const { name, value } = e.target;
        setConsultaFiscalizacao({
            ...consultaFiscalizacao,
            [name]: value
        })
    }

    //Função para listar as fiscalizações com base nos filtros
    const handleConsultaFiscalicacao = (filtro = null) => {
        if (!filtro) {
            //Realizando a validação dos campos obrigatorios
            const _errors = validarCampos(consultaFiscalizacao, campos);
            setErrors(_errors[0]);

            if (_errors[1].length > 0)
                return true;

            //Data Inicial/Final são opcionais quando Nome do Infrator, Endereço, Código do Item ou Código de Cadastro forem informados
            const possuiFiltroAlternativo = !!(consultaFiscalizacao.nomeInfrator || consultaFiscalizacao.logradouro ||
                consultaFiscalizacao.bairro || consultaFiscalizacao.numero || consultaFiscalizacao.codigoItem ||
                consultaFiscalizacao.codigoCadastro);

            if (!possuiFiltroAlternativo && (!consultaFiscalizacao.dataFiscalizacaoInicial || !consultaFiscalizacao.dataFiscalizacaoFinal)) {
                showMessage("Aviso", "Informe o período de datas ou ao menos um dos filtros: Nome do Infrator, Endereço, Código do Item ou Código de Cadastro.", "warning", null)
                return true;
            }

            if (consultaFiscalizacao.dataFiscalizacaoInicial && consultaFiscalizacao.dataFiscalizacaoFinal &&
                isDateOverflow(consultaFiscalizacao.dataFiscalizacaoInicial, consultaFiscalizacao.dataFiscalizacaoFinal, 12, 'months')) {
                showMessage("Aviso", "A pesquisa deve ter um período máximo de 12 meses!", "warning", null)
                return true;
            }
        }

        setLoading(true);
        fiscalizacao_api.GetConsultaFiscalizacao(filtro != null ? filtro : consultaFiscalizacao)
            .then(response => {
                response.data?.map(v => {
                    v.dataFiscalizacao = moment(v.dataFiscalizacao).format("DD/MM/YYYY");
                    v.dataHoraPreenchimento = moment(v.dataHoraPreenchimento).format("DD/MM/YYYY");
                    return v;
                })
                setListFiscalizacoes(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    return <>
        <h4 className='text-secondary m-0'>Consulta Fiscalização</h4>
        <Row className='mt-3 p=0'>
            <Col md={12} lg={6}>
                <TextField
                    type={"select"}
                    name={"tipoFiscalizacao_Ids"}
                    label={"* Tipo de fiscalização"}
                    multiple
                    options={listTipoDeFiscalizacao}
                    onChange={onChangeMultiSelect}
                    value={listTipoDeFiscalizacao.filter(value => (consultaFiscalizacao.tipoFiscalizacao_Ids ?? []).includes(value.value))}
                    invalid={!!errors.tipoFiscalizacao_Ids}
                />
            </Col>
            <Col md={12} lg={session && session.realizaFiscalizacao ? 6 : 3}>
                <TextField
                    type={"text"}
                    name={"nomeInfrator"}
                    label={"Nome do Infrator"}
                    onChange={onChange}
                    value={consultaFiscalizacao.nomeInfrator}
                />
            </Col>
            <Col md={12} lg={3} className={session && session.realizaFiscalizacao ? "d-none" : ""}>
                <TextField
                    type={"select"}
                    name={"usuario_Id"}
                    label={"Usuario"}
                    searchable
                    options={listUsuarios}
                    onChange={onChangeSelect}
                    value={listUsuarios.filter(value => value.value == consultaFiscalizacao.usuario_Id)}
                />
            </Col>
            <Col md={12} lg={6}>
                <TextField
                    type={"text"}
                    name={"logradouro"}
                    label={"Logradouro"}
                    onChange={onChange}
                    value={consultaFiscalizacao.logradouro}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"text"}
                    name={"bairro"}
                    label={"Bairro"}
                    onChange={onChange}
                    value={consultaFiscalizacao.bairro}
                />
            </Col>
            <Col md={12} lg={2}>
                <TextField
                    type={"number"}
                    name={"numero"}
                    label={"Numero"}
                    onChange={onChange}
                    value={consultaFiscalizacao.numero}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    name={"codigoItem"}
                    label={"Código do item"}
                    onChange={onChange}
                    value={consultaFiscalizacao.codigoItem}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    name={"codigoCadastro"}
                    label={"Código de cadastro"}
                    onChange={onChange}
                    value={consultaFiscalizacao.codigoCadastro}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"select"}
                    name={"situacao"}
                    label={"* Situação"}
                    options={situacao}
                    onChange={onChange}
                    value={consultaFiscalizacao.situacao}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"select"}
                    name={"periodoDatas"}
                    label={"* Período de Datas"}
                    onChange={onChange}
                    options={[
                        { label: "Data Lavratura", value: "Data Lavratura" },
                        { label: "Data da infração", value: "Data da infração" },
                    ]}
                    value={consultaFiscalizacao.periodoDatas}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"date"}
                    name={"dataFiscalizacaoInicial"}
                    label={"Data inicial"}
                    onChange={onChange}
                    value={consultaFiscalizacao.dataFiscalizacaoInicial}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"date"}
                    name={"dataFiscalizacaoFinal"}
                    label={"Data Final"}
                    onChange={onChange}
                    value={consultaFiscalizacao.dataFiscalizacaoFinal}
                />
            </Col>


        </Row>
        <Row className='text-center align-items-center mb-3'>
            <Col md={12} lg={12}>
                <Button
                    color='primary'
                    className='text-white fw-bold'
                    onClick={() => handleConsultaFiscalicacao()}
                >
                    <FontAwesomeIcon icon={faFilter} /> Filtrar
                </Button>
            </Col>
        </Row>
        <TabelaListagem
            actions={actions}
            title={"Lista de fiscalizacões"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={listFiscalizacoes}
        />
    </>;
}

export default ConsultaFiscalizacao;
